<template>
  <div class="phoneVerification">

    <div>
      <a-steps :current="current">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps>
      <div class="steps-content">
        <!-- {{ steps[current].content }} -->
      </div>
      <div class="steps-action">
        <!--  -->
        <div v-if="current==0">
          <a-form :form="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }" class="m-t-80">
            <a-form-item label="手机号码" required>
              <a-input v-model:value="account" style="width:270px" placeholder="请输入手机号码" maxlength="11" readonly/>
            </a-form-item>
            <a-form-item label="验证码" required>
              <a-row :gutter="8">
                <a-col :span="12">
                  <a-input v-model:value="code" maxlength="6" />
                </a-col>
                <a-col :span="12">
                  <a-button @click="getCode()">{{text}}</a-button>
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item label="" :wrapper-col="{ span: 12,offset:8 }" class="m-t-30">
              <a-row :gutter="8">
                <a-col :span="5">
                  <a-button type="primary" @click="next()">提交</a-button>
                </a-col>
                <a-col :span="12" :push="1">
                  <div @click="$router.push('/forgetpasswordtwo?account='+$route.query.account)" class="s_c376 s_shou">重新选择验证方式</div>
                </a-col>
              </a-row>
            </a-form-item>
          </a-form>
        </div>
        <!--  -->
        <div v-if="current==1">
          <a-form :form="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }" class="m-t-80">
            <a-form-item label="新的密码" required>
              <a-input-password v-model:value="password" style="width:300px" placeholder="请输入新的密码" maxlength="20" type="password" />
            </a-form-item>
            <a-form-item label="确认密码" required>
              <a-input-password v-model:value="password_again" style="width:300px" placeholder="请再次确认密码" maxlength="20" type="password" />
            </a-form-item>

            <!-- <a-form-item name="password" :rules="[{ required: true, message: '请输入密码' }]">
                    <a-input-password v-model:value="formModel.password" placeholder="密码">
                      <template #prefix>
                        <img src="@/assets/images/mima-5@2x.png" width="20" height="20" alt="">
                      </template>
                    </a-input-password>
                  </a-form-item> -->

            <a-form-item label="" :wrapper-col="{ span: 12,offset:8 }" class="m-t-30">
              <a-row :gutter="8">
                <a-col :span="5">
                  <a-button type="primary" @click="next2()">下一步</a-button>
                </a-col>
                <a-col :span="12" :push="1">
                  <div @click="$router.push('/forgetpasswordtwo?account='+$route.query.account)" class="s_c376 s_shou">重新选择验证方式</div>
                </a-col>
              </a-row>
            </a-form-item>
          </a-form>
          <!-- <a-button type="primary" @click="next()">下一步</a-button>
          <a-button @click="prev">上一步</a-button> -->
        </div>
        <!--  -->
        <div v-if="current==2" :style="{display:'flex',justifyContent: 'center',alignContent: 'center',flexDirection: 'column',textAlign:'center'}">
          <CheckCircleOutlined :style="{fontSize:'50px',marginTop:'30px'}" />
          <div :style="{fontSize:'26px',marginTop:'15px'}">密码已重置</div>
          <div style="color:#FAC752;font-size:16px;marginTop:15px">此页面会在5秒后自动跳转到登录面.....{{sec}}秒</div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { message } from "ant-design-vue";
import { reactive, ref, toRefs,inject,onMounted } from 'vue';
import { CheckCircleOutlined } from '@ant-design/icons-vue';
import { retrievePasswordCode,postCodeCheck,postReset } from '@/api/login';
import { iscode } from '@/utils/app';
export default {
  components: { CheckCircleOutlined },
  setup() {
    const $router = inject('$router');
    const $route = inject('$route')
    const form = reactive({
      account: '',
      code: '',
      codeStatus: false,
      text: '获取验证码',
      password:'',
      password_again:'',
      sec:1,
      key:''
    });
    const current = ref(0);
    const steps = reactive([
      {
        title: '验证身份',
      },
      {
        title: '重置登录密码',
      },
      {
        title: '完成',
      },
    ]);
    //提交一
    const next = async () => {
      const hide = message.loading('正在提交中...', 0);
       let res = await postCodeCheck({ phone: form.account,code:form.code}).then((res) => res.data)
       setTimeout(hide);
       if(iscode(res,true)){
         console.log(res)
         form.key = res.data.key
         current.value++;
       }
      
    };
    const prev = () => {
      current.value--;
    };
    //获取验证码
    const getCode = async () => {
      if(!form.account) {
        message.error('请先输入手机号码')
        return
      }
       if(form.account.length!=11) {
        message.error('手机号码不正确')
        return
      }
      if (form.codeStatus) {
         message.error('倒计时结束后再发送')
      } else {
        let time = null;
        let i = 1;
        form.codeStatus = true;
        time = setInterval(() => {
          
          form.text = i + 's后重新获取';
          i++
          if (i >= 60) {
            clearInterval(time);
            console.log(i)
            form.text = '获取验证码';
            form.codeStatus = false;
          }
        }, 1000);
      };

      let res = await retrievePasswordCode({ phone: form.account}).then((res) => res.data)
      iscode(res,true)

    };

    //提交二
    const next2 = async ()=>{
       if(!form.password||form.password.length<6){
          message.error('密码为 6 ~ 20位字符，包含数字、字母、特殊符号')
          return
       }
        if(form.password_again != form.password){
          message.error('二次输入的密码不一致')
          return
       }

      let res = await postReset({ password: form.password,password_again:form.password_again,key:form.key}).then((res) => res.data)
    if(iscode(res,true)){
       current.value++;
       let time = null;
       time = setInterval(()=>{
          form.sec++
          if(form.sec>=5){
            clearInterval(time)
            form.sec= 0
            $router.push('/login')
          }
      },1000)
      }
     

    }

    onMounted(()=>{
      form.account = $route.query.account
    })

    return {
      ...toRefs(form),
      current,
      next,
      prev,
      steps,
      getCode,
      next2
    };
  },
};
</script>
<style lang="less" scoped>
.phoneVerification {
  width: 100%;

  height: 320px;
  background: #f8f8f8;
  padding: 30px;
  .bor_rad {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #fff;
    text-align: center;
    line-height: 40px;
  }
  .s_flex_center {
    flex-direction: column;
  }
  .bar {
    width: 220px;
    height: 5px;
    background: #fff;
  }
}
.ant-form-item {
  margin-bottom: 0px;
}
/deep/ .ant-steps-item-title::after{
  background-color: #333 !important;
}
</style>